import { UserManagerSettings } from 'oidc-client-ts';

const oidcConfig: UserManagerSettings = {
  authority: import.meta.env.VITE_AUTHORITY!,
  client_id: import.meta.env.VITE_CLIENT_ID!,
  redirect_uri: `${import.meta.env.VITE_FRONTEND_API}/callback`,
  post_logout_redirect_uri: `${import.meta.env.VITE_FRONTEND_API}/logout-callback`,
  response_type: 'code',
  scope: 'openid profile roles tis_api_fts_portal offline_access',
  automaticSilentRenew: true,
  loadUserInfo: true,
};

export default oidcConfig;
